import { gql } from '@apollo/client';
import { Box } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { CellProps } from 'react-table';
import { PlaylistTable_PlaylistFragment } from '../__generated__/PlaylistTable.graphql';

export function TitleCell({
  value,
}: PropsWithChildren<CellProps<PlaylistTable_PlaylistFragment, string>>) {
  return (
    <Box overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" fontWeight="semibold">
      {value}
    </Box>
  );
}

TitleCell.graphql = {
  fragments: {
    TitleCell_playlist: gql`
      fragment TitleCell_playlist on Playlist {
        id
        title
      }
    `,
  },
};
